import { useEffect, useState } from "react";
import { Col, Row, Spin, Tooltip } from "antd";
import axios from "axios";

import internSVG from "../../../assets/icons/Intern.svg";
import mgfSVG from "../../../assets/icons/MGF.svg";
import nurseSVG from "../../../assets/icons/Nurse.svg";
import othersSVG from "../../../assets/icons/Others.svg";
import clinicalSVG from "../../../assets/icons/Clinical-Secretary.svg";
import notPayed from "../../../assets/icons/Not-Payed-Quotas.svg";
import dropoutsImg from "../../../assets/icons/Users-apagados.svg";
import deletedUsersImg from "../../../assets/icons/Users-eliminados.svg";
import payedAssoc from "../../../assets/icons/quotas-amarelo.svg";
import associatesTotal from "../../../assets/icons/Associates-Total-Number.svg";
import eventsCalendar from "../../../assets/icons/Events-Calendar.svg";
import endpoints from "../../../utils/endoinpts";
import "./Dashboard.css";
import { useOutletContext } from "react-router-dom";
import dayjs from "dayjs";
import { InfoCircleOutlined } from "@ant-design/icons";

export default function DashBoard() {
  const { user } = useOutletContext();

  const [isLoading, setIsLoading] = useState(true);
  const [totalUsers, setTotalUsers] = useState([]);
  const [totalAssociatedUsers, setTotalAssociatedUsers] = useState([]);
  const [totalUsersValid, setTotalUsersValid] = useState([]);
  const [totalUsersNotValid, setTotalUsersNotValid] = useState([]);
  const [totalUsersDropouts, setTotalUsersDropouts] = useState([]);
  const [totalDeletedUsers, setTotalDeletedUsers] = useState([]);
  const [totalEvents, setTotalEvents] = useState([]);
  const [totalDoctors, setTotalDoctors] = useState([]);
  const [totalInterns, setTotalInterns] = useState([]);
  const [totalNurses, setTotalNurses] = useState([]);
  const [totalSecretaries, setTotalSecretaries] = useState([]);
  const [totalOthers, setTotalOthers] = useState([]);
  const [usersNotPayedText, setUsersNotPayedText] = useState(0);

  useEffect(() => {
    handleGetAdminInfo();
  }, []);

  function handleGetAdminInfo() {
    axios
      .get(endpoints.info.getDashboardData)
      .then((res) => {
        let auxDash = res.data;

        let total_users = auxDash[0];
        let total_events = auxDash[1];

        let total_doctors = auxDash[2];
        let total_interns = auxDash[3];
        let total_nurses = auxDash[4];
        let total_secretaries = auxDash[5];
        let total_others = auxDash[6];

        let users_active = [];
        let users_inactive = [];
        let users_dropouts = [];
        let total_users_not_valid = [];

        let users_not_payed = total_users.filter((u) => u.payment_valid === 0 && u.is_deleted === 0);
        let total_users_valid = total_users.filter((u) => u.payment_valid === 1 && u.is_deleted === 0);
        let deleted_users = total_users.filter((u) => u.is_deleted === 1);

        for (let i = 0; i < users_not_payed.length; i++) {
          let valid_access_date = dayjs(users_not_payed[i].valid_access_date);
          let today = dayjs();
          let yearsAccess = today.diff(valid_access_date, "year");
          if (yearsAccess < 1) {
            users_active.push(users_not_payed[i]);
            total_users_not_valid.push(users_not_payed[i]);
          } else {
            if (yearsAccess >= 3) users_dropouts.push(users_not_payed[i]);
            else {
              users_inactive.push(users_not_payed[i]);
              total_users_not_valid.push(users_not_payed[i]);
            }
          }
        }

        let auxUsersNotPayed = (
          <div>
            <p className="text-[12px] m-0">Ativos: {users_active.length}</p>
            <p className="text-[12px] mt-2 mb-0">Inativos: {users_inactive.length}</p>
          </div>
        );

        setUsersNotPayedText(auxUsersNotPayed);
        setTotalUsers(total_users);
        setTotalAssociatedUsers(total_users.filter((u) => u.is_deleted === 0));
        setTotalUsersValid(total_users_valid);
        setTotalUsersNotValid(total_users_not_valid);
        setTotalUsersDropouts(users_dropouts);
        setTotalEvents(total_events);
        setTotalDoctors(total_doctors);
        setTotalInterns(total_interns);
        setTotalNurses(total_nurses);
        setTotalSecretaries(total_secretaries);
        setTotalOthers(total_others);
        setTotalDeletedUsers(deleted_users);

        setTimeout(() => {
          setIsLoading(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <Spin spinning={isLoading}>
      <div className="dash_card_admin grid grid-cols-6">
        <div className="flex flex-col justify-center items-center">
          <img className="w-full max-w-[90px]" src={associatesTotal} />
          <p className="mt-4 text-[14px]">Sócios</p>
          <div className="flex items-start  mt-2">
            <p className="text-[40px] font-[600] leading-none">{totalAssociatedUsers.length}</p>
            <Tooltip className="text-[12px] ml-1" placement="right" title={<p className="text-[12px]">Somatório dos Sócios Válidos, Por pagar e Desistentes.</p>}>
              <InfoCircleOutlined />
            </Tooltip>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center">
          <img className="w-full max-w-[90px]" src={payedAssoc} />
          <p className="mt-4 text-[14px]">Válidos</p>
          <p className="text-[40px] font-[600] mt-2">{totalUsersValid.length}</p>
        </div>
        <div className="flex flex-col justify-center items-center">
          <img className="w-full max-w-[90px]" src={notPayed} />
          <p className="mt-4 text-[14px]">Por pagar</p>
          <div className="flex items-start  mt-2">
            <p className="text-[40px] font-[600] leading-none">{totalUsersNotValid.length}</p>
            <Tooltip className="text-[12px] ml-1" placement="right" title={usersNotPayedText}>
              <InfoCircleOutlined />
            </Tooltip>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center">
          <img className="w-full max-w-[90px]" src={dropoutsImg} />
          <p className="mt-4 text-[14px]">Desistentes</p>
          <p className="text-[40px] font-[600] mt-2 leading-none">{totalUsersDropouts.length}</p>
        </div>
        <div className="flex flex-col justify-center items-center">
          <img className="w-full max-w-[90px]" src={deletedUsersImg} />
          <p className="mt-4 text-[14px]">Eliminados</p>
          <p className="text-[40px] font-[600] mt-2 leading-none">{totalDeletedUsers.length}</p>
        </div>
        <div className="flex flex-col justify-center items-center">
          <img className="w-full max-w-[90px]" src={eventsCalendar} />
          <p className="mt-4 text-[14px]">Eventos</p>
          <p className="text-[40px] font-[600] mt-2 leading-none">{totalEvents.length}</p>
        </div>
      </div>
      <div className="grid grid-cols-5 gap-4 mt-[20px]">
        <div className="flex flex-col justify-center p-[20px] bg-white rounded-[5px]">
          <img className="w-full max-w-[60px]" src={mgfSVG} />
          <p className="mt-2 text-[14px]">Médico de Família</p>
          <div className="flex items-start mt-2">
            <p className="text-[30px] leading-none font-[600]" style={{ fontWeight: 600, lineHeight: 1 }}>
              {totalDoctors.length}
            </p>
            <Tooltip
              className="text-[12px] ml-1"
              placement="right"
              title={<p className="text-[12px] m-0">Aposentados: {totalDoctors?.filter((item) => item.retiree === 1).length}</p>}
            >
              <InfoCircleOutlined />
            </Tooltip>
          </div>
        </div>
        <div className="flex flex-col justify-center p-[20px] bg-white rounded-[5px]">
          <img className="w-full max-w-[60px]" src={internSVG} />
          <p className="mt-2 text-[14px]">Médico Interno</p>

          <p className="text-[30px] leading-none font-[600] mt-2">{totalInterns.length}</p>
        </div>
        <div className="flex flex-col justify-center p-[20px] bg-white rounded-[5px]">
          <img className="w-full max-w-[60px]" src={nurseSVG} />
          <p className="mt-2 text-[14px]">Enfermeiro</p>
          <div className="flex items-start mt-2">
            <p className="text-[30px] leading-none font-[600]">{totalNurses.length}</p>
            <Tooltip className="text-[12px]" placement="right" title={<p className="text-[12px] m-0">Aposentados: {totalNurses?.filter((item) => item.retiree === 1).length}</p>}>
              <InfoCircleOutlined />
            </Tooltip>
          </div>
        </div>
        <div className="flex flex-col justify-center p-[20px] bg-white rounded-[5px]">
          <img className="w-full max-w-[60px]" src={clinicalSVG} />
          <p className="mt-2 text-[14px] mt-2">Secretário Clínico</p>
          <div className="flex items-start mt-2">
            <p className="text-[30px] leading-none font-[600]" style={{ fontWeight: 600, lineHeight: 1 }}>
              {totalSecretaries.length}
            </p>
            <Tooltip
              className="text-[12px]"
              placement="right"
              title={<p className="text-[12px] m-0">Aposentados: {totalSecretaries?.filter((item) => item.retiree === 1).length}</p>}
            >
              <InfoCircleOutlined />
            </Tooltip>
          </div>
        </div>
        <div className="flex flex-col justify-center p-[20px] bg-white rounded-[5px]">
          <img className="w-full max-w-[60px]" src={othersSVG} />
          <p className="text-[14px] mt-2">Outros</p>
          <div className="flex items-start mt-2">
            <p className="text-[30px] leading-none font-[600]">{totalOthers.length}</p>

            <Tooltip className="text-[12px]" placement="right" title={<p className="text-[12px] m-0">Aposentados: {totalOthers?.filter((item) => item.retiree === 1).length}</p>}>
              <InfoCircleOutlined />
            </Tooltip>
          </div>
        </div>
      </div>
    </Spin>
  );
}
